import React from 'react'
import { IClinicNumber } from '@dataTypes/clinic.type'
import { formatPhoneNumber } from '@utils/numberFormatter.util'
import ReviewSections from '../../../shared/ReviewSections'

interface ReviewInfoProps {
  numberData: IClinicNumber
  price: string
}

const ReviewInfo: React.FC<ReviewInfoProps> = ({ numberData, price }) => {
  const renewsOn = new Date()
  renewsOn.setMonth(renewsOn.getMonth() + 1)
  const renewsOnFormatted = `${String(renewsOn.getMonth() + 1).padStart(2, '0')}/${String(
    renewsOn.getDate(),
  ).padStart(2, '0')}/${renewsOn.getFullYear()}`

  return (
    <ReviewSections
      sections={[
        {
          id: 'number',
          title: 'Number',
          showInfo: true,
          fields: [
            {
              label: 'Selected number',
              value: formatPhoneNumber(numberData.phone_number, false),
            },
          ],
        },
        {
          id: 'billing',
          title: 'Billing',
          showInfo: true,
          fields: [
            { label: 'Renews on', value: renewsOnFormatted },
            { label: 'Total due', value: `$${price}` },
          ],
        },
      ]}
    />
  )
}

export default ReviewInfo
